import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

const StyledCheckboxInput = (props, context) => {
  const {
    input,
    label,
    meta: { touched, error },
    checkbox,
    onChange,
    id,
    disabled,
    hideLabel,
    checkValue /** Used to check the checkbox using a value that doesn't come from the API. Can be controlled by a state from parent component. */,
  } = props;
  const validationState = touched && !!error ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";
  const groupClassName =
    (props.groupClassName || "") +
    " " +
    classNames({
      "styled-checkbox": true,
      disabled: disabled,
    });

  const checked =
    !!(input.checked ||
    input.value.toString().indexOf(checkbox.value.toString()) !== -1 ||
    checkValue);

  

  return (
    <FormGroup
      className={groupClassName}
      controlId={id + scene}
      validationState={validationState}
    >
      <div className="input-wrapper">
        <label>
          <input
            {...input}
            disabled={disabled}
            className="styled"
            type="checkbox"
            name={input.name}
            id={input.name}
            onChange={(e) => {
              onChange && onChange(e);
              return input.onChange(e);
            }}
            checked={checked}
            value={checkbox.value}
          />
          <span className="checkbox-styler" />
        </label>
      </div>
      {label && !hideLabel && (
        <ControlLabel>
          {label}
          {touched && error && (
            <HelpBlock>
              <FormattedMessage
                id={validationMessageKey}
                values={validationValues}
              />
            </HelpBlock>
          )}
        </ControlLabel>
      )}
    </FormGroup>
  );
};

StyledCheckboxInput.propTypes = {
  checkbox: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  validation: PropTypes.object,
  hideLabel: PropTypes.bool,
  checkValue: PropTypes.bool,
};

export default StyledCheckboxInput;



// WEBPACK FOOTER //
// ./src/components/common/form/StyledCheckboxInput.js